module.exports = __webpack_public_path__ + "413bd98485c84f2a5b3f48b386cfd81d.svg";